import { useState } from "react";
import { aiWritingAssistantRepo } from "@/lib/repositories";
import type { ApiDilemma } from "@/features/dilemmas/types";
import type { AiRefineRequest } from "../types";

// Imperative wrapper (no useMutation) so the global MutationCache error toast
// doesn't fire on top of the caller's own catchError handling.
export function useRefineDilemma() {
  const [isPending, setIsPending] = useState(false);

  async function refine(
    id: string,
    payload: AiRefineRequest,
  ): Promise<ApiDilemma> {
    setIsPending(true);
    try {
      return await aiWritingAssistantRepo.refine(id, payload);
    } finally {
      setIsPending(false);
    }
  }

  return { refine, isPending };
}
